import React from "react";
import { Col, Form } from "react-bootstrap";
import AdvancedInput, { Transformation } from "controls/advancedInput";
import { ValidationControlBase } from "@frui.ts/bootstrap";
import { IBindingProps } from "@frui.ts/views";
import { bound } from "@frui.ts/helpers";

export interface AuthCodeInputProps {
  translate: (code: string) => string;
  onBlur?: (e: React.FormEvent<any>) => void;
}

export default class AuthCodeInput<TTarget> extends ValidationControlBase<TTarget, AuthCodeInputProps & IBindingProps<TTarget>> {
  ignoredCharacters = new RegExp(/[^A-Z0-9]+/gi);

  @bound
  protected renderInner() {
    const { target, property, translate, onBlur } = this.props;

    return (
      <Form.Group controlId="auth-code-input" as={Col} sm={12} xl={6}>
        <Form.Label>{translate("authorizationCode")}</Form.Label>
        <AdvancedInput
          transformation={Transformation.UpperCased}
          target={target}
          property={property}
          ignoredCharacters={this.ignoredCharacters}
          onBlur={onBlur}
          autoComplete="off"
        />
      </Form.Group>
    );
  }
}
